import { Account } from '@/models/account';
import { AccountService } from '@/services/accounts';
import { errorCatch } from '../utils';
import { make } from 'vuex-pathify';

export const accountService = new AccountService();

export const state = {
  accounts: [],
  currentUser: {},
  loading: false,
  error: {}
};

export const mutations = {
  ADD_ACCOUNT(state: any, payload: Account) {
    state.accounts.push(payload);
  },

  SET_ACCOUNTS(state: any, payload: Account[]) {
    state.accounts = payload;
  },

  UPDATE_ACCOUNT(state: any, payload: Account) {
    const index = state.accounts.findIndex(
      (account: Account) => account.id === payload.id
    );
    state.accounts.splice(index, 1, payload);
  },

  REMOVE_ACCOUNT(state: any, payload: number) {
    const index = state.accounts.findIndex(
      (account: Account) => account.id === payload
    );
    state.accounts.splice(index, 1);
  },

  SET_CURRENT_USER(state: any, payload: Account) {
    state.currentUser = payload;
  },

  SET_LOADING(state: any, payload: boolean) {
    state.loading = payload;
  },

  SET_ERROR(state: any, error: any) {
    errorCatch(state, error);
  },

  CLEAR_ERROR(state: any) {
    state.error = {};
  }
};

export const actions = {
  clearError: ({ commit }: any) => commit('CLEAR_ERROR'),

  createAccount: async ({ commit, dispatch }: any, payload: Account) => {
    dispatch('clearError');
    commit('SET_LOADING', true);

    await new Promise((resolve, reject) => {
      accountService
        .createAccount(payload)
        .then(account => {
          commit('ADD_ACCOUNT', account);
          resolve();
        })
        .catch(err => {
          commit('SET_ERROR', err);
          //TODO: LF - 2020-03-08: Finalize how to handle error
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },

  fetchAccounts: async ({ commit, dispatch }: any) => {
    dispatch('clearError');
    commit('SET_LOADING', true);

    return await new Promise((resolve, reject) => {
      accountService
        .fetchAccounts()
        .then(accounts => {
          commit('SET_ACCOUNTS', accounts);
          resolve(accounts);
        })
        .catch(err => {
          commit('SET_ERROR', err);
          //TODO: LF - 2020-03-08: Finalize how to handle error
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },

  fetchMe: async ({ commit, state, dispatch }: any) => {
    dispatch('clearError');
    commit('SET_LOADING', true);

    await new Promise((resolve, reject) => {
      accountService
        .fetchMe()
        .then(account => {
          commit('SET_CURRENT_USER', account);
          console.log(accountService.getCurrentUserEvents());
          console.log(accountService.events);

          const accounts = [...state.accounts];
          const index = accounts.findIndex((a: Account) => a.id === account.pk);

          resolve();
        })
        .catch(err => {
          commit('SET_ERROR', err);
          //TODO: LF - 2020-03-08: Finalize how to handle error
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },
  fetchAccount: async ({ commit, state, dispatch }: any, payload: number) => {
    dispatch('clearError');
    commit('SET_LOADING', true);

    await new Promise((resolve, reject) => {
      accountService
        .fetchAccount(payload)
        .then(account => {
          const accounts = [...state.accounts];
          const index = accounts.findIndex((a: Account) => a.id === payload);
          if (index === -1) {
            commit('ADD_ACCOUNT', account);
          } else {
            commit('UPDATE_ACCOUNT', account);
          }
          resolve();
        })
        .catch(err => {
          commit('SET_ERROR', err);
          //TODO: LF - 2020-03-08: Finalize how to handle error
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },

  updateAccount: async ({ commit, dispatch }: any, payload: Account) => {
    dispatch('clearError');
    commit('SET_LOADING', true);

    await new Promise((resolve, reject) => {
      accountService
        .updateAccount(payload.id, payload)
        .then(account => {
          commit('UPDATE_ACCOUNT', account);
          resolve();
        })
        .catch(err => {
          commit('SET_ERROR', err);
          //TODO: LF - 2020-03-08: Finalize how to handle error
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },

  deleteAccount: async ({ commit, dispatch }: any, payload: number) => {
    dispatch('clearError');
    commit('SET_LOADING', true);

    await new Promise((resolve, reject) => {
      accountService
        .deleteAccount(payload)
        .then(() => {
          commit('REMOVE_ACCOUNT', payload);
          resolve();
        })
        .catch(err => {
          commit('SET_ERROR', err);
          //TODO: LF - 2020-03-08: Finalize how to handle error
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  }
};

export const getters = {
  getLoading: (state: any) => state.loading,
  getCurrentUser: (state: any) => state.currentUser,
  getInitials: (state: any): string =>
    `${state.currentUser.first_name} ${state.currentUser.last_name}`
      .toUpperCase()
      .split(' ')
      .map(n => n[0])
      .join(''),
  getFullName: (state: any): string =>
    `${state.currentUser.first_name} ${state.currentUser.last_name}`,
  ...make.getters(state),

  getAccountsByName: (state: any) =>
    state.accounts.map(
      (account: Account) => `${account.first_name} ${account.last_name}` ?? ''
    )
};
